module.exports = __webpack_public_path__ + "img/mellat.787dc415.png";